import { conditionalBranchMessage } from '../functions'

export default {
  function: {
    upload_common: {
      conditional_branch_message: (args: any) =>
        conditionalBranchMessage(args, (triggerQuestionSelectMetaList) => {
          if (triggerQuestionSelectMetaList.length === 1) {
            const { categoryName, questionDisplayNumber, selectText } = triggerQuestionSelectMetaList[0]
            return `For those who answered '${selectText}' in No. ${questionDisplayNumber} of ${categoryName} (mandatory).`
          }

          const messages = triggerQuestionSelectMetaList.map(
            ({ categoryName, questionDisplayNumber, selectText }) => {
              return `'${selectText}' in No. ${questionDisplayNumber} of ${categoryName}`
            }
          )
          return `For those who answered ${messages.join(' or ')}. (Mandatory question)`
        }),
    },
    validation: {
      decimal_max_digit: (args: any) => {
        const rawValue = args.named('decimalMaxDigit')
        const value = rawValue ? `${rawValue}` : ''
        const digit =
          value === '1'
            ? `${value}st`
            : value === '2'
              ? `${value}nd`
              : value === '3'
                ? `${value}rd`
                : `${value}th`
        return `Type in up to ${digit} decimal place.`
      },
    },
  }
}
